const toString = Object.prototype.toString;
const hasOwn = Object.prototype.hasOwnProperty;
/* eslint-disable */
function isApp() {
  return /shihang_app/.test(window.navigator.userAgent.toLowerCase()) || this.from === 'app'
}

function isArray(val) {
  return toString.call(val) === '[object Array]'
}

function isString(val) {
  return typeof val === 'string'
}

function isObject(val) {
  return val !== null && typeof val === 'object'
}

function isDate(val) {
  return toString.call(val) === '[object Date]'
}

function isFunction(val) {
  return toString.call(val) === '[object Function]'
}

function isWithValidProperties(obj, checks) {
  if (!isObject(obj)) return false
  if (isArray(obj)) return false
  if (isFunction(obj)) return false
  if (isDate(obj)) return false
  for (let key in checks) {
    if (hasOwn.call(obj, key) && hasOwn.call(checks, key)) {
      const checkFns = isArray(checks[key]) ? checks[key] : [checks[key]]
      const result = checkFns.every(fn => fn.call(null, obj[key]))
      if (result === false) return result
    } else {
      return false
    }
  }
  return true
}

function parseJson(str, flag = undefined) {
  if (!isString(str)) return flag
  try {
    return JSON.parse(str)
  } catch (error) {
    return flag
  }
}

function checkTocCity(obj) {
  return isWithValidProperties(obj, {
    CityFlag: isString,
    CityName: isString
  })
}

function checkTocToken(obj) {
  return isWithValidProperties(obj, {
    AccessToken: isString,
    CustomerGuid: isString
  })
}
function isIPhoneXR(fn){
  var u = navigator.userAgent;
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isIOS) {    	
      if ((screen.height == 896 && screen.width == 414) ){
        return true
        //是iphoneX
      }else{
        return false
        //不是iphoneX
      } 
  }
}
/**
 * 
 * 将格式为"xxxx-xx-xx xx:xx:xx" 转换成时间戳
 */
function convertDatefromString(str) {
  if (str) { 
    str = str.substring(0,19);    
    str = str.replace(/-/g,'/'); //必须把日期'-'转为'/'
    return new Date(str).getTime();
  } 
}

/**
 * 版本号比较工具
 */
function compareVersion(target) {
  const targetToString =
    typeof target === "string" ? target : target.toString();
  const rawNums = targetToString.split(".");
  const plainPadding = ["0000", "000", "00", "0", ""];
  for (let i = 0; i < rawNums.length; i++) {
    const len = rawNums[i].length;
    rawNums[i] = plainPadding[len] + rawNums[i];
  }
  return rawNums.join("");
}

export {
  isArray,
  isDate,
  isFunction,
  isObject,
  isString,
  checkTocCity,
  checkTocToken,
  parseJson,
  isWithValidProperties,
  isIPhoneXR,
  convertDatefromString,
  compareVersion
}
